import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingStatesService {
  private readonly isLoadingValues: Map<string, boolean> = new Map();
  private readonly isLoadingValueSubject = new BehaviorSubject<
    Map<string, boolean>
  >(this.isLoadingValues);
  isLoadingValue$ = this.isLoadingValueSubject.asObservable();

  setIsLoadingValue(definitionId: string, value: boolean): void {
    this.isLoadingValues.set(definitionId, value);
    this.isLoadingValueSubject.next(new Map(this.isLoadingValues));
  }
}
